import Link from "next/link"

export default function CustomNotFoundPage() {
  return (
    <div className="h-[50vh] justify-center flex flex-col align-middle items-center gap-6">
      <h1 className="text-8xl font-bold ">404</h1>
      <h2 className="text-xl capitalize ">Page not found</h2>
      <Link
        href="/"
        className="px-6 py-2 rounded-md bg-[#8DC63F] text-white hover:bg-white hover:text-[#8DC63F] border border-[#8DC63F] transition duration-300"
      >
        Back to homepage
      </Link>
    </div>
  )
}
